import { LOGIN, LOGOUT, SET_CART_COUNT } from "./ActionConstants";

export const reducer = (state: any, action: any) => {
  switch (action.type) {
    case LOGIN:
      return {
        ...state,
        auth: {
          token: action.payload.token,
          refreshToken: action.payload.refreshToken ?? null,
          user: action.payload.user
        }
      };
    case LOGOUT:
      return {
        ...state,
        auth: {
          token: null,
          refreshToken: null,
          user: null
        },
        cartCount: 0,
      };
    case SET_CART_COUNT:
      if (Number(state.cartCount ?? 0) === Math.max(0, Number(action.payload ?? 0))) {
        return state;
      }
      return {
        ...state,
        cartCount: Math.max(0, Number(action.payload ?? 0)),
      };
    default:
      return state;
  }
};
